<!--=============================
=            INVOICE            =
==============================-->

<template>
  <!-- page blank -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Invoice</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            <div class="row">
              <div class="col-md-3 align-self-center">
                <img class="logo-invoice" src="../../assets/img/logo.png" />
              </div>
            </div>
          </div>
          <div slot="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class>
                  <h6 class="mb-0">
                    <b>Order Date :</b> 31/01/2020
                  </h6>
                  <h6>
                    <b>Order ID :</b> # 23654789
                  </h6>
                </div>
              </div>
              <div class="col-md-3">
                <div class="float-left">
                  <address class="font-13">
                    <strong class="font-14">Billed To :</strong>
                    <br />Joe Smith
                    <br />795 Folsom Ave
                    <br />San Francisco, CA 94107
                    <br />
                    <abbr title="Phone">P:</abbr> (123) 456-7890
                  </address>
                </div>
              </div>
              <div class="col-md-3">
                <div class>
                  <address class="font-13">
                    <strong class="font-14">Shipped To:</strong>
                    <br />Joe Smith
                    <br />795 Folsom Ave
                    <br />San Francisco, CA 94107
                    <br />
                    <abbr title="Phone">P:</abbr> (123) 456-7890
                  </address>
                </div>
              </div>
              <div class="col-md-3">
                <div class="text-center bg-light p-3 mb-3">
                  <h5 class="bg-info mt-0 p-2 text-white d-sm-inline-block">Payment Methods</h5>
                  <h6 class="font-13">Paypal & Cards Payments :</h6>
                  <p class="mb-0 text-muted">CompanyA/c.paypal@gmai.com</p>
                  <p class="mb-0 text-muted">Visa, Master Card, Chaque</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="table-responsive">
                  <table class="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>Quantity</th>
                        <th>Item</th>
                        <th>Description</th>
                        <th>Unit Cost</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>2</th>
                        <td>LCD</td>
                        <td>There are many variations of passages of Lorem Ipsum available.</td>
                        <td>$555.00</td>
                        <td>$1110.00</td>
                      </tr>
                      <tr>
                        <th>1</th>
                        <td>Mobile</td>
                        <td>It is a long established fact that a reader will be distracted.</td>
                        <td>$100.00</td>
                        <td>$100.00</td>
                      </tr>
                      <tr>
                        <th>3</th>
                        <td>Chair</td>
                        <td>Contrary to popular belief, Lorem Ipsum is not simply random text.</td>
                        <td>$30.00</td>
                        <td>$90.00</td>
                      </tr>
                      <tr>
                        <th>1</th>
                        <td>Camera</td>
                        <td>Aldus PageMaker including versions of Lorem Ipsum.</td>
                        <td>$999.00</td>
                        <td>$999.00</td>
                      </tr>
                      <tr>
                        <th>3</th>
                        <td>Headphone</td>
                        <td>Various versions have evolved over the years, sometimes by accident.</td>
                        <td>$20.00</td>
                        <td>$60.00</td>
                      </tr>
                      <tr>
                        <td colspan="3" class="border-0"></td>
                        <td class="border-0 font-14">
                          <b>Sub Total</b>
                        </td>
                        <td class="border-0 font-14">
                          <b>$2359.00</b>
                        </td>
                      </tr>
                      <tr>
                        <th colspan="3" class="border-0"></th>
                        <td class="border-0 font-14">
                          <b>Tax Rate</b>
                        </td>
                        <td class="border-0 font-14">
                          <b>$0.00%</b>
                        </td>
                      </tr>
                      <tr class="bg-dark text-white">
                        <th colspan="3" class="border-0"></th>
                        <td class="border-0 font-14">
                          <b>Total</b>
                        </td>
                        <td class="border-0 font-14">
                          <b>$2359.00</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-lg-6">
                <h5 class="mt-4">Terms And Condition :</h5>
                <ul class="pl-3">
                  <li>
                    <small>All accounts are to be paid within 7 days from receipt of invoice.</small>
                  </li>
                  <li>
                    <small>To be paid by cheque or credit card or direct payment online.</small>
                  </li>
                  <li>
                    <small>
                      If account is not paid within 7 days the credits details supplied as confirmation
                      <br />of work undertaken will be charged the agreed quoted fee noted above.
                    </small>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 align-self-end">
                <div class="w-25 float-right">
                  <small>Account Manager</small>
                  <img src="../../assets/img/ass.png" alt class height="48" />
                  <p class="border-top">Signature</p>
                </div>
              </div>
            </div>
            <hr />
            <div class="row d-flex justify-content-center">
              <div class="col-lg-12 col-xl-4 ml-auto align-self-center">
                <div class="text-center text-muted">
                  <small>Thank you very much for doing business with us. Thanks !</small>
                </div>
              </div>
              <div class="col-lg-12 col-xl-4">
                <div class="float-right d-print-none">
                  <a href="javascript:window.print()" class="btn btn-info white--text ma-2">
                    <i class="fa fa-print"></i>
                  </a>
                  <a href="#" class="btn btn-primary white--text ma-2">Submit</a>
                  <a href="#" class="btn btn-danger white--text ma-2">Cancel</a>
                </div>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  }
};
</script>
<style scoped>
.logo-invoice{
  width: 50px;
  height: 50px;
}

</style>
<!--====  End of INVOICE  ====-->
